// PRODUCT PREVIEW IMAGE

if (document.body.id === 'artical-page') {

    // RATING STARS
    $('.JSrev-star i').each(function(i, el){
        var val = 0;
        $(el).on('click', function(){    
            $(el).addClass('bi-star-fill').removeClass('bi-star'); 
            $(el).prevAll('i').addClass('bi-star-fill').removeClass('bi-star'); 
            $(el).nextAll('i').removeClass('bi-star-fill').addClass('bi-star'); 
            if (i == 0) { val = 1; }
            else if(i == 1){ val = 2; }
            else if(i == 2){ val = 3; }
            else if(i == 3){ val = 4; }
            else if(i == 4){ val = 5; } 
            $('#JSreview-number').val(val); 
        }); 
    }); 

    // Custom Modal
    document.querySelectorAll('.elevatezoom-gallery').forEach(function (thumbnail) {
        thumbnail?.addEventListener('click', function () {
            var slideIndex = this.getAttribute('data-slide-to');

            var newImageSrc = this.getAttribute('data-image');

            // Find the corresponding carousel item image
            var imgElement = document.querySelector('#carousel-image-' + slideIndex);
            if (imgElement) {
                imgElement.src = newImageSrc;
            }

            var carousel = document.querySelector('#productModalContent');
            var carouselInstance = bootstrap.Carousel.getInstance(carousel);
            if (!carouselInstance) {
                carouselInstance = new bootstrap.Carousel(carousel);
            }
            carouselInstance.to(slideIndex);
        });
    });

    // Count Images
    const carousel = document.getElementById('productModalContent');
    const imageFrom = document.querySelector('.image-from');
    const totalImages = parseInt(document.querySelector('.image-to').textContent, 10); // Total number of images
    const imageCountFrom = 1;

    imageFrom.textContent = imageCountFrom;

    carousel?.addEventListener('slide.bs.carousel', function(event) {
        const nextIndex = event.to + 1;
        imageFrom.textContent = nextIndex;
    });
    // End of Count Images

    const artImg = document.getElementById('art-img');
    const modalCarousel = document.getElementById('productModal');
    const modalCarouselInner = modalCarousel.querySelector('.carousel-inner');
    const additionalImages = Array.from(document.querySelectorAll('.slider-additional-images a'));
    const leftButton = document.querySelector('.JSleft_btn');
    const rightButton = document.querySelector('.JSright_btn');
    let currentIndex = 0;

    // Function to update both the main image and the modal carousel
    function updateImage(index) {
        const image = additionalImages[index];
        if (image) {
            // Update main image
            const newImageSrc = image.getAttribute('data-main-image') || image.getAttribute('data-image');
            const zoomImageSrc = image.getAttribute('data-zoom-image') || image.getAttribute('data-image');
            artImg.src = newImageSrc;
            artImg.setAttribute('data-zoom-image', zoomImageSrc);

            // Update modal carousel
            const slides = modalCarouselInner.querySelectorAll('.carousel-item');
            slides.forEach((slide, i) => {
                slide.classList.toggle('active', i === index);
            });

            currentIndex = index;
        }
    }

    // Event listeners for additional images
    additionalImages.forEach((image, index) => {
        image?.addEventListener('click', function() {
            updateImage(index);
        });
    });


    // Event listeners for navigation buttons
    leftButton?.addEventListener('click', function () {
        const newIndex = (currentIndex === 0) ? additionalImages.length - 1 : currentIndex - 1;
        updateImage(newIndex);
    });

    rightButton?.addEventListener('click', function () {
        const newIndex = (currentIndex === additionalImages.length - 1) ? 0 : currentIndex + 1;
        updateImage(newIndex);
    });

    updateImage(currentIndex);

    // Sync slider images
    const modalCarouselContent = document.getElementById('productModalContent');

    function updateModalCarousel(index) {
        const carouselItems = modalCarouselContent.querySelectorAll('.carousel-item');
        carouselItems.forEach(item => item.classList.remove('active'));

        const activeCarouselItem = modalCarousel.querySelector(`#carousel-image-${index}`).closest('.carousel-item');
        activeCarouselItem.classList.add('active');
    }

    const elevateZoomImages = document.querySelectorAll('.elevatezoom-gallery');
    const mainImage = document.querySelector('#art-img');
    const zoomImage = document.querySelector('#zoom_03');
    const sliderInner = document.querySelector('.additional-images-inner');
    const scrollAmount = 100;

    function updateMainImage(index) {
        const selectedImage = elevateZoomImages[index].querySelector('img');
        const newSrc = elevateZoomImages[index].getAttribute('data-main-image') || selectedImage.src;
        const newZoomSrc = elevateZoomImages[index].getAttribute('data-zoom-image') || selectedImage.src;

        mainImage.src = newSrc;
        zoomImage.setAttribute('data-zoom-image', newZoomSrc);

        elevateZoomImages.forEach((imgContainer, i) => {
            if (i === index) {
                imgContainer.classList.add('active');
            } else {
                imgContainer.classList.remove('active');
            }
        });

        updateModalCarousel(index);

        scrollSliderToImage(index);
    }

    function scrollSliderToImage(index) {
        const selectedImage = elevateZoomImages[index].querySelector('img');
        const sliderInnerRect = sliderInner.getBoundingClientRect();
        const selectedImageRect = selectedImage.getBoundingClientRect();

        if(selectedImageRect.left < sliderInnerRect.left) {
            sliderInner.scrollBy({
                left: -scrollAmount,
                behavior: 'smooth'
            });
        } else if(selectedImageRect.right > sliderInnerRect.right) {
            sliderInner.scrollBy({
                left: scrollAmount,
                behavior: 'smooth'
        })
    }
}

// Quantity
const minusButton = document.getElementById('quantity-minus');
const plusButton = document.getElementById('quantity-plus');
const cartAmountInput = document.getElementById('cartAmount');

minusButton?.addEventListener('click', function() {
    let cartAmount = parseInt(cartAmountInput.value);
    if (!isNaN(cartAmount) && cartAmount > 1) {
        cartAmountInput.value = cartAmount - 1;
    }
});

plusButton?.addEventListener('click', function() {
    let cartAmount = parseInt(cartAmountInput.value);
    if (!isNaN(cartAmount)) {
        cartAmountInput.value = cartAmount + 1;
    }
});

// Ensure the value cannot be left empty
cartAmountInput?.addEventListener('input', function() {
    if (this.value === '' || parseInt(this.value) < 1) {
        this.value = 1;
    }
});
}
